export default "__VITE_ASSET__BXBq40mM__"